import React, { useEffect, useState } from 'react';
import styles from './lucianamendesvr.module.scss';
import perfil from './src/perfil.png';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import TiktokIcon from '../../icons/tiktokIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';

const EMAIL = 'creatorlumendes@gmail.com';
const INSTAGRAM_URL = 'https://www.instagram.com/luciana.mendes.vr/';
const ICON_COLOR = '#83213a';

const TIKTOK_PERFIS = [
    {
        handle: '@luciana.mendes.vr',
        href: 'https://www.tiktok.com/@luciana.mendes.vr',
    },
    {
        handle: '@luciana.indica',
        href: 'https://www.tiktok.com/@luciana.indica',
    },
];

type CupomCard = {
    id: number;
    image: string;
    brand: string;
    cupom: string;
    site: string;
    nota?: string;
};

type ActiveModal = CupomCard | 'tiktok' | null;

const cardImages: CupomCard[] = [
    {
        id: 1,
        image: require('./src/57.png'),
        brand: 'USENADA',
        cupom: 'LUCIANAMENDES10G',
        site: 'https://www.usenada.com.br/discount/LUCIANAMENDES10G?utm_source=&utm_medium=&utm_campaign=&utm_content=LUCIANAMENDES10G',
    },
    {
        id: 2,
        image: require('./src/58.png'),
        brand: 'Aura Beauty',
        cupom: 'LUMENDES',
        site: 'https://aurabeautyclub.com.br/?utm_source=yahoo_organic&utm_content=%7C%7Cnemu_XrcqbZ6tmw',
    },
    {
        id: 3,
        image: require('./src/59.png'),
        brand: 'Mawwal',
        cupom: 'LUCIANA',
        site: 'https://mawwal.com.br',
    },
    {
        id: 4,
        image: require('./src/60.png'),
        brand: 'Cléa Store',
        cupom: 'LUMENDES',
        site: 'https://www.cleastore.com.br/essenciais',
    },
    {
        id: 5,
        image: require('./src/61.png'),
        brand: 'Insider',
        cupom: 'LUBRAGA',
        site: 'https://www.insiderstore.com.br/discount/LUBRAGA?redirect=/collections/outlet/?utm_source=influmkt&utm_medium=3c994aaa&utm_campaign=LUBRAGA&cupom=LUBRAGA',
    },
    {
        id: 6,
        image: require('./src/62.png'),
        brand: 'Perfumistta',
        cupom: 'LUMENDES10',
        site: 'https://perfumistta.com.br/?_su_rec=b0WwGYhztfKbyjF8aWS6RpYw6IRFwwKD1YUgQ_9hu113FJ_HZtSKleRKZuuH1nv6rpNCHuORt85eCF1qKj5OoNcb68TE06RGSb5uSTF4S7aQ1eT-eZT5M81aXdB9dvmNa7r0c8-_HtpNsxRJ5QiKXHxLvWICgUNfJ7CMCBJhd9Sl8lJxjvS8wQXkOptxlvecqZVw_qMhK2AiidLUadMCk9INcNpuSmHCo7Zk_E3pqSIdJYmBPsTzFVZaVCVAroOpa16mafu6LG2kMmgiyXKPv7F9j72tERmXztNwv2-XOYkhxjROWjnHSidl85MgoGlN4QovqQ&_su_rec_id=61e4be2d-eb93-4bcd-abd0-23373e4716a0-1792416255',
    },
];

const Lucianamendesvr: React.FC = () => {
    const [activeModal, setActiveModal] = useState<ActiveModal>(null);
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        if (!activeModal) return;

        const onKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') setActiveModal(null);
        };

        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        window.addEventListener('keydown', onKeyDown);

        return () => {
            document.body.style.overflow = prevOverflow;
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [activeModal]);

    useEffect(() => {
        setCopied(false);
    }, [activeModal]);

    const handleCopy = async (cupom: string) => {
        try {
            await navigator.clipboard.writeText(cupom);
            setCopied(true);
            window.setTimeout(() => setCopied(false), 1800);
        } catch {
            setCopied(false);
        }
    };

    const cupomAtivo = activeModal && activeModal !== 'tiktok' ? activeModal : null;

    return (
        <div className={styles.lucianamendesvr}>
            <div className={styles.container}>
                <img src={perfil} alt="Luciana Mendes" className={styles.perfil} />

                <div className={styles.socialRow}>
                   
                    <a href={`mailto:${EMAIL}`} className={styles.socialLink} aria-label="E-mail">
                        <svg
                            height="24"
                            width="24"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                        >
                            <path
                                fill={ICON_COLOR}
                                d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5L4 8V6l8 5 8-5v2z"
                            />
                        </svg>
                    </a>
                    <a
                        href={INSTAGRAM_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.socialLink}
                        aria-label="Instagram"
                    >
                        <InstagramIcon height="22" color={ICON_COLOR} />
                    </a>
                    <button
                        type="button"
                        className={styles.socialLink}
                        onClick={() => setActiveModal('tiktok')}
                        aria-label="TikTok"
                    >
                        <TiktokIcon height="22" color={ICON_COLOR} />
                    </button>
                </div>

                <div className={styles.cards}>
                    {cardImages.map((card) => (
                        <button
                            type="button"
                            key={card.id}
                            className={styles.card}
                            onClick={() => setActiveModal(card)}
                            aria-label={`Abrir ${card.brand}`}
                        >
                            <img src={card.image} alt={card.brand} />
                        </button>
                    ))}
                </div>
            </div>

            {activeModal && (
                <div
                    className={styles.modalOverlay}
                    onClick={() => setActiveModal(null)}
                    role="presentation"
                >
                    <div
                        className={styles.modal}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="lucianamendesvr-modal-title"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            type="button"
                            className={styles.modalClose}
                            onClick={() => setActiveModal(null)}
                            aria-label="Fechar"
                        >
                            ×
                        </button>

                        {activeModal === 'tiktok' ? (
                            <>
                                <p className={styles.modalEyebrow}>TikTok</p>
                                <h2 id="lucianamendesvr-modal-title" className={styles.modalBrand}>
                                    Escolha o perfil
                                </h2>
                                <div className={styles.tiktokList}>
                                    {TIKTOK_PERFIS.map((perfil) => (
                                        <a
                                            key={perfil.handle}
                                            href={perfil.href}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className={styles.tiktokBtn}
                                        >
                                            <TiktokIcon height="20" color="currentColor" />
                                            <span>{perfil.handle}</span>
                                        </a>
                                    ))}
                                </div>
                            </>
                        ) : cupomAtivo ? (
                            <>
                                <p className={styles.modalEyebrow}>
                                    {cupomAtivo.nota ?? 'Cupom exclusivo'}
                                </p>
                                <h2 id="lucianamendesvr-modal-title" className={styles.modalBrand}>
                                    {cupomAtivo.brand}
                                </h2>
                                <div className={styles.cupomBox}>
                                    <span className={styles.cupomLabel}>Seu cupom</span>
                                    <span className={styles.cupomCode}>{cupomAtivo.cupom}</span>
                                    <button
                                        type="button"
                                        className={styles.copyBtn}
                                        onClick={() => handleCopy(cupomAtivo.cupom)}
                                    >
                                        {copied ? 'Copiado!' : 'Copiar cupom'}
                                    </button>
                                </div>
                                <a
                                    href={cupomAtivo.site}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={styles.siteBtn}
                                >
                                    Ir para o site
                                </a>
                            </>
                        ) : null}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Lucianamendesvr;
